import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IGetMeetingCostPayload } from '@app-store/slices/meetings/getMeetingCost'

interface TaskAction extends Action {
    payload: IGetMeetingCostPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.getMeetingCost

function* getMmeetingCostSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting/costs/meeting`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getMmeetingCostSaga(): any {
    yield takeLatest<TaskAction>(onRequest, getMmeetingCostSagaTask)
}

export default getMmeetingCostSaga
